import React from "react";
import { useEffect, useState } from "react";
import { GraphDropDown } from "../../components/Graphs/GraphDropDown";
import "../../components/Graphs/graphStyles.scss";
import { FirebaseDataService } from "../../services/firebase-data.service.jsx";
import { getCookie } from "../../helper/cookie/cookie";
import {
  setSecondLevelStates,
  setCurrentDate2,
  setDateType2,
  setDates2,
  setCurrentSources,
  setAllDates2,
  setDates,
  setWeeklyData2,
  setBiWeeklyData2,
  setMonthlyData2,
  setQuarterlyData2,
  setHalfYearlyData2,
  setYearlyData2,
} from "./firstlastSlice";
import { useDispatch, useSelector } from "react-redux";
import { DateTypeDropdown } from "./DateTypeDropdown";
import { ExportCSVButton } from "../../components/ExportCSVButton";
import Modal from "@mui/material/Modal";
import { dbTouch } from "../../firebase";
import { ref, get, child } from "firebase/database";
import { selectLogInUsername } from "../../common/authenticateDashboard/authSlice.js";
import FirstLastTouchLoading2 from "../../components/Skeletons/FirstLastTouchLoading2.jsx";

const DATEOPTIONS = [
  "Weekly",
  "Bi-Weekly",
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
];

const MONTHS = {
  "01": "January",
  "02": "Feburary",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "December",
};

const QUARTERS = {
  "01": "Jan-Mar",
  "02": "Jan-Mar",
  "03": "Jan-Mar",
  "04": "Apr-Jun",
  "05": "Apr-Jun",
  "06": "Apr-Jun",
  "07": "Jul-Sep",
  "08": "Jul-Sep",
  "09": "Jul-Sep",
  10: "Oct-Dec",
  11: "Oct-Dec",
  12: "Oct-Dec",
};

const HALFYEARS = {
  "01": "Jan-Jun",
  "02": "Jan-Jun",
  "03": "Jan-Jun",
  "04": "Jan-Jun",
  "05": "Jan-Jun",
  "06": "Jan-Jun",
  "07": "Jul-Dec",
  "08": "Jul-Dec",
  "09": "Jul-Dec",
  10: "Jul-Dec",
  11: "Jul-Dec",
  12: "Jul-Dec",
};

const fakeData = [
  {
    fist_source: "organic",
    last_source: "organic",
    no_of_sales: 20,
    subData: [
      {
        fist_source: "google_organic",
        last_source: "_organic",
        no_of_sales: 12,
        subData: [
          {
            referrers: ["google.com"],
            user_source: {
              utm_source: ["Google-Search"],
              utm_medium: ["google-cpc"],
              utm_campaign: ["Rockwell_US_Brand_Exact"],
              utm_term: ["rockwell safety razor"],
            },
            no_of_sales: 4,
          },
          {
            referrers: ["google.com"],
            user_source: {
              utm_source: ["DM | Welcome Series"],
              utm_medium: ["email"],
              utm_campaign: ["Welcome Series, Email #1 (Tsepn5)"],
            },
            no_of_sales: 8,
          },
        ],
      },
      {
        fist_source: "youtube_organic",
        last_source: "bing_organic",
        no_of_sales: 8,
        subData: [],
      },
    ],
  },
  {
    fist_source: "organic",
    last_source: "paid",
    no_of_sales: 20,
    subData: [
      {
        fist_source: "google_organic",
        last_source: "paid",
        no_of_sales: 12,
        subData: [
          {
            referrers: ["google.com"],
            user_source: {
              utm_source: ["Google-Search"],
              utm_medium: ["google-cpc"],
              utm_campaign: ["Rockwell_US_Brand_Exact"],
              utm_term: ["rockwell safety razor"],
            },
            no_of_sales: 4,
          },
          {
            referrers: ["google.com"],
            user_source: {
              utm_source: ["DM | Welcome Series"],
              utm_medium: ["email"],
              utm_campaign: ["Welcome Series, Email #1 (Tsepn5)"],
              utm_campaignid: ["testing"],
            },
            no_of_sales: 8,
          },
        ],
      },
      {
        fist_source: "youtube_organic",
        last_source: "paid",
        no_of_sales: 8,
        subData: [],
      },
    ],
  },
];

export function TouchGraph2() {
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];


  const [loading, setLoading] = React.useState(true);
  const dispatch = useDispatch();

  // Current array of dates to be displayed, current date, and current date type
  const dates = useSelector((state) => state.firstLast.graph2.dates);
  const currentDate = useSelector(
    (state) => state.firstLast.graph2.currentDate
  );
  const dateType = useSelector((state) => state.firstLast.graph2.dateType);

  // list of dates in different formats
  const weekly = useSelector((state) => state.firstLast.graph2.weekly);
  const biWeekly = useSelector((state) => state.firstLast.graph2.biWeekly);
  const monthly = useSelector((state) => state.firstLast.graph2.monthly);
  const quarterly = useSelector((state) => state.firstLast.graph2.quarterly);
  const halfYearly = useSelector((state) => state.firstLast.graph2.halfYearly);

  // Current data to be displayed
  const currentSources = useSelector(
    (state) => state.firstLast.graph2.currentSources
  );

  // All data in different date formats
  const weeklyData = useSelector((state) => state.firstLast.graph2.weeklyData);
  const biWeeklyData = useSelector(
    (state) => state.firstLast.graph2.biWeeklyData
  );
  const monthlyData = useSelector(
    (state) => state.firstLast.graph2.monthlyData
  );
  const quarterlyData = useSelector(
    (state) => state.firstLast.graph2.quarterlyData
  );
  const halfYearlyData = useSelector(
    (state) => state.firstLast.graph2.halfYearlyData
  );

  // handles what second level states are open
  const secondLevelStates = useSelector(
    (state) => state.firstLast.secondLevelStates
  );

  // modal open flag and data to be given to modal
  const [openModal, setOpenModal] = React.useState(false);
  // const [openModal2, setOpenModal2] = React.useState(false)
  // const [openModal3, setOpenModal3] = React.useState(false)
  // const [openModal4, setOpenModal4] = React.useState(false)

  const [modalData, setModalData] = React.useState(null);

  const handleClose = () => {
    setOpenModal(false);
  };
  // const handleClose2 = () => { setOpenModal2(false) }
  // const handleClose3 = () => { setOpenModal3(false) }
  // const handleClose4 = () => { setOpenModal4(false) }

  useEffect(() => {
    function fetchData() {
      try {
        if (dates?.length === 0) {
          const dbRef = ref(dbTouch);
          let statsObj = user.split("@")[0] + "/graph-first_last_touch_weekly";

          get(child(dbRef, statsObj)).then((data) => {
            const dataArray = data.val();

            // Set current dates, default to weekly dates
            dispatch(
              setDates2(dataArray?.map((val) => Object.keys(val)[0]).reverse())
            );
            dispatch(
              setWeeklyData2(
                dataArray
                  ?.map((val) => Object.values(val)[0])
                  ?.slice()
                  .reverse()
              )
            );
            // Current data being dislpayed
            dispatch(
              setCurrentSources(
                dataArray
                  ?.map((val) => Object.values(val)[0])
                  ?.slice()
                  .reverse()
              )
            );

            let dates_list = dataArray?.map((val) => Object.keys(val)[0]);

            // Get only unique data points in array -> unique monthly dates
            function onlyUnique(value, index, array) {
              return array.indexOf(value) === index;
            }
            // Monthly dates
            const monthArr = dates_list
              ?.map((value) => {
                return (
                  MONTHS[`${value.substring(5, 7)}`] +
                  " " +
                  value.substring(0, 4)
                );
              })
              ?.filter(onlyUnique);
            // Quarterly dates
            const quarterArr = dates_list
              ?.map((value) => {
                return (
                  QUARTERS[`${value.substring(5, 7)}`] +
                  " " +
                  value.substring(0, 4)
                );
              })
              ?.filter(onlyUnique);
            // HalfYearly dates
            const halfYearlyArr = dates_list
              ?.map((value) => {
                return (
                  HALFYEARS[`${value.substring(5, 7)}`] +
                  " " +
                  value.substring(0, 4)
                );
              })
              ?.filter(onlyUnique);
            // Set bi-weekly, monthly, quarterly, bi-monthly, dates
            dispatch(
              setAllDates2({
                weekly: dates_list?.slice().reverse(),
                biWeekly: dates_list
                  ?.filter((value, index) => index % 2 === 0)
                  ?.slice()
                  .reverse(),
                monthly: monthArr?.reverse(),
                quarterly: quarterArr?.reverse(),
                halfYearly: halfYearlyArr?.reverse(),
              })
            );
          });

          // Bi-weekly data from db
          statsObj = user.split("@")[0] + "/graph-first_last_touch_biweekly";
          get(child(dbRef, statsObj)).then((data) => {
            const dataArray = data.val();
            dispatch(setBiWeeklyData2(dataArray?.slice().reverse()));
          });
          // monthly data from db
          statsObj = user.split("@")[0] + "/graph-first_last_touch_monthly";
          get(child(dbRef, statsObj)).then((data) => {
            const dataArray = data.val();
            dispatch(setMonthlyData2(dataArray?.slice().reverse()));
          });
          //quarterly data from db
          statsObj = user.split("@")[0] + "/graph-first_last_touch_quarterly";
          get(child(dbRef, statsObj)).then((data) => {
            const dataArray = data.val();
            dispatch(setQuarterlyData2(dataArray?.slice().reverse()));
          });
          // half-yearly data from db
          statsObj = user.split("@")[0] + "/graph-first_last_touch_halfyearly";
          get(child(dbRef, statsObj)).then((data) => {
            const dataArray = data.val();
            dispatch(setHalfYearlyData2(dataArray?.slice().reverse()));
          });
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  /**
   * When dateType is change by clicking button from middle dropdown,
   * changes firstSources, lastSources, uniqueSales states to match the
   * data from that particular date type selected
   */
  useEffect(() => {
    const changeData = () => {
      if (currentSources?.length !== 0) {
        switch (dateType) {
          case 0:
            if (dates !== weekly) {
              dispatch(setDates2(weekly));
              dispatch(dispatch(setCurrentDate2(0)));
              dispatch(setCurrentSources(weeklyData));
            }
            break;
          case 1:
            if (dates !== biWeekly) {
              dispatch(setDates2(biWeekly));
              dispatch(setCurrentDate2(0));
              dispatch(setCurrentSources(biWeeklyData));
            }
            break;
          case 2:
            if (dates !== monthly) {
              dispatch(setDates2(monthly));
              dispatch(setCurrentDate2(0));
              dispatch(setCurrentSources(monthlyData));
            }
            break;
          case 3:
            if (dates !== quarterly) {
              dispatch(setDates2(quarterly));
              dispatch(setCurrentDate2(0));
              dispatch(setCurrentSources(quarterlyData));
            }
            break;
          default:
            if (dates !== halfYearly) {
              dispatch(setDates2(halfYearly));
              dispatch(setCurrentDate2(0));
              dispatch(setCurrentSources(halfYearlyData));
            }
            break;
        }
      }
    };
    changeData();
  }, [dateType, currentDate]);

  // State flag that control layout styling at different widths
  const [layoutWidthFlag, setLayoutWidthFlag] = React.useState(
    window.innerWidth >= 640 ? false : true
  );
  const [maxSmallWidth, setMaxSmallWidth] = React.useState(
    window.innerWidth >= 550 ? false : true
  );
  const [isMobile, setIsMobile] = React.useState(
    window.innerWidth >= 768 ? false : true
  );
  const [titleFlag, setTitleFlag] = React.useState(
    window.innerWidth >= 830 ? false : true
  );
  const [modalBoxFlag, setModalBoxFlag] = React.useState(
    window.innerWidth >= 1000 ? false : true
  );
  // check if the screen is mobile for header layout
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else setIsMobile(false);
      if (window.innerWidth < 640) {
        setLayoutWidthFlag(true);
      } else setLayoutWidthFlag(false);
      if (window.innerWidth < 830) {
        setTitleFlag(true);
      } else setTitleFlag(false);
      if (window.innerWidth < 550) {
        setMaxSmallWidth(true);
      } else {
        setMaxSmallWidth(false);
      }
      if (window.innerWidth < 1000) {
        setModalBoxFlag(true);
      } else {
        setModalBoxFlag(false);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize(); // initial check
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Initializes array of booleans all to false to represent
  // which second level show buttons are open
  useEffect(() => {
    let openFlags = [];
    currentSources?.map((value, index) => {
      openFlags[index] = false;
    });
    dispatch(setSecondLevelStates(openFlags));
  }, [dateType, currentDate]);

  // Updates state of array of booleans that represents
  // which second level show buttons are open
  function openSecondLevel(idx) {
    let copyOpenFlags = [...secondLevelStates];
    if (secondLevelStates[idx]) {
      copyOpenFlags[idx] = false;
      dispatch(setSecondLevelStates(copyOpenFlags));
    } else {
      copyOpenFlags[idx] = true;
      dispatch(setSecondLevelStates(copyOpenFlags));
    }
  }

  // Gives the modal all current second level data and the index
  // of the second level data that's selected
  function handleOpenModal(data, idx) {
    setModalData({ data: data, idx: idx });
    setOpenModal(true);
  }

  // State changing functions to be passed into components
  function changeDateType(num) {
    dispatch(setDateType2(num));
  }

  // State changing functions to be passed into components
  function changeCurrentDate(num) {
    dispatch(setCurrentDate2(num));
  }

  return (
    <div className="graph rounded-2 mb-5">
      {/* Graph header */}
      <div
        className={`flex ${
          layoutWidthFlag ? "justify-content-center" : "justify-content-between"
        } align-items-center p-2.5 px-2.5 bg-[rgba(0,0,0,0.05)] flex-wrap gap-2`}
      >
        {/* Title */}
        <div style={{ fontSize: `${titleFlag ? "13.5px" : "15px"}` }}>
          First and Last Touch Insight
        </div>
        {/* Drop down buttons and CVS Button */}
        <div
          className="flex"
          style={{
            width: `${layoutWidthFlag ? "" : "65%"}`,
            justifyContent: `${layoutWidthFlag ? "" : "space-between"}`,
          }}
        >
          <div className="flex">
            <DateTypeDropdown
              dateType={DATEOPTIONS[dateType]}
              setDateType={changeDateType}
            />
            <GraphDropDown
              display={"firstlasttouch"}
              currentWeek={currentDate}
              setCurrentWeek={changeCurrentDate}
              weeks={dates}
            />
          </div>
          <div>
            <ExportCSVButton
              allData={
                currentDate
                  ? dates[currentDate] === undefined
                    ? []
                    : [
                        [
                          "First Source",
                          ...currentSources[currentDate]
                            ?.slice()
                            ?.map((val) => [val.first_source]),
                        ],
                        [
                          "Last Source",
                          ...currentSources[currentDate]
                            ?.slice()
                            ?.map((val) => val.last_source),
                        ],
                        [
                          "No of Unique Sales",
                          ...currentSources[currentDate]
                            ?.slice()
                            ?.map((val) => val.no_of_sales),
                        ],
                      ]
                  : []
              }
              name={"First_Last_Touch_Insight"}
              style={{
                fontSize: "13px",
                height: "37.5px",
                marginTop: "4px",
                maxWidth: "105px",
                marginRight: "0px",
              }}
            />
          </div>
        </div>
      </div>

      <div
        className="flex flex-col ml-3.5 mr-3.5 mb-4 mt-4"
        style={{ border: "1px solid rgba(0,0,0,0.1)" }}
      >
        {/* Header row with labels */}
        <div
          className="fw-bold flex"
          style={{
            border: "1px solid rgba(0,0,0,0.1)",
            fontSize: `${
              layoutWidthFlag ? (maxSmallWidth ? "10px" : "12px") : "13px"
            }`,
          }}
        >
          {/* First Source Label */}
          <div
            className="flex pl-2 mt-2.5 mb-2.5 text-nowrap"
            style={{
              width: `${isMobile ? "32%" : titleFlag ? "30%" : "29%"}`,
              maxWidth: `${layoutWidthFlag ? "22vw" : "24.5vw"}`,
            }}
          >
            First Source
          </div>
          {/* Last Source Label */}
          <div
            className="flex mt-2.5 text-nowrap"
            style={{
              width: `${isMobile ? "34%" : titleFlag ? "32%" : "31%"}`,
            }}
          >
            Last Source
          </div>
          {/* Unique Sales Label */}
          <div
            className="flex mt-2.5 text-nowrap"
            style={{
              width: `${
                layoutWidthFlag ? "18.9%" : titleFlag ? "20.9%" : "23.9%"
              }`,
            }}
          >
            {titleFlag ? "Unique Sales" : "No of Unique Sales"}
          </div>
          {/* Details Label */}
          <div className="flex mt-2.5 pl-2" style={{ width: "11%" }}>
            Details
          </div>
        </div>
        <div>
          {loading ||
          (currentSources !== null && currentSources?.length === 0) ||
          (currentSources !== null &&
            currentSources?.length >= currentDate - 1 &&
            currentSources[currentDate] === undefined) ? (
            <FirstLastTouchLoading2 />
          ) : (
            <div>
              {/* All data */}
              {currentSources !== null &&
                currentSources?.length >= currentDate - 1 &&
                currentSources[currentDate]?.map((value, index) => (
                  <div key={index}>
                    {/* First level of data */}
                    <div
                      className="flex"
                      style={{
                        borderTop: "0.5px solid rgba(0,0,0,0.1)",
                        fontSize: `${
                          layoutWidthFlag
                            ? maxSmallWidth
                              ? "10px"
                              : "12px"
                            : "13px"
                        }`,
                        backgroundColor: "rgba(220, 240, 220, 0.7)",
                      }}
                    >
                      {/* First Sources */}
                      <div
                        className="flex pl-2 pt-3 pb-3 text-nowrap"
                        style={{
                          width: `${
                            isMobile ? "32%" : titleFlag ? "30%" : "29%"
                          }`,
                          maxWidth: `${layoutWidthFlag ? "22vw" : "24.5vw"}`,
                        }}
                      >
                        {value["first_source"]}
                      </div>
                      {/* Last Sources */}
                      <div
                        className="flex pt-3 pb-3 text-nowrap"
                        style={{
                          width: `${
                            isMobile ? "34%" : titleFlag ? "32%" : "31%"
                          }`,
                        }}
                      >
                        {value["last_source"]}
                      </div>
                      {/* Unique Sales */}
                      <div
                        className="flex pt-3 text-nowrap"
                        style={{
                          width: `${
                            layoutWidthFlag
                              ? "18.9%"
                              : titleFlag
                              ? "20.9%"
                              : "23.9%"
                          }`,
                        }}
                      >
                        {value["no_of_sales"]}
                      </div>
                      {/* Details */}
                      <div className="flex" style={{ width: "11%" }}>
                        <button
                          className={`px-${
                            maxSmallWidth ? "2.5" : "3"
                          } text-white rounded-4 mt-2.5 ${
                            secondLevelStates[index]
                              ? "first__level__button__pressed"
                              : "first__level__button"
                          }`}
                          onClick={() => openSecondLevel(index)}
                        >
                          {secondLevelStates[index] ? "hide" : "show"}
                        </button>
                      </div>
                    </div>

                    {/* Second level of data */}
                    {secondLevelStates[index] ? (
                      <div className="flex flex-col">
                        {value.subData?.map((innerValue, idx) => (
                          <div
                            className="flex"
                            key={idx}
                            style={{
                              borderTop: "0.5px solid rgba(0,0,0,0.1)",
                              fontSize: `${
                                layoutWidthFlag
                                  ? maxSmallWidth
                                    ? "10px"
                                    : "12px"
                                  : "13px"
                              }`,
                              backgroundColor: "rgba(220, 220, 255, 0.7)",
                            }}
                          >
                            {/* First Sources */}
                            <div
                              className="pl-5 pt-3 pb-2.5 pr-2"
                              style={{
                                width: `${
                                  isMobile ? "32%" : titleFlag ? "30%" : "29%"
                                }`,
                                wordWrap: "break-word",
                                maxWidth: `${
                                  layoutWidthFlag ? "22vw" : "24.5vw"
                                }`,
                              }}
                            >
                              {innerValue["first_source"]}
                            </div>

                            {/* Last Sources */}
                            <div
                              className="pt-3 pl-3 pr-2 pb-2.5"
                              style={{
                                wordWrap: "break-word",
                                width: `${
                                  isMobile ? "34%" : titleFlag ? "32%" : "31%"
                                }`,
                              }}
                            >
                              {innerValue["last_source"]}
                            </div>

                            {/* Unique Sales */}
                            <div
                              className="flex pt-3"
                              style={{
                                width: `${
                                  layoutWidthFlag
                                    ? "18.9%"
                                    : titleFlag
                                    ? "20.9%"
                                    : "23.9%"
                                }`,
                              }}
                            >
                              {innerValue["no_of_sales"]}
                            </div>

                            {/* Details */}
                            <div className="flex" style={{ width: "11%" }}>
                              <button
                                className={`px-${
                                  maxSmallWidth ? "2.5" : "3"
                                } text-white rounded-4 mt-2 second__level__button`}
                                onClick={() =>
                                  handleOpenModal(value.subData, idx)
                                }
                              >
                                Show
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                ))}

              {/* Third Level Popup Modal */}
              {openModal ? (
                <ModalDisplay
                  modalData={modalData}
                  modalBoxFlag={modalBoxFlag}
                  setOpenModal={setOpenModal}
                  setModalData={setModalData}
                  currentDate={currentDate}
                  dates={dates}
                  openModal={openModal}
                  handleClose={handleClose}
                  dateType={dateType}
                />
              ) : (
                <div></div>
              )}

              {/* Bottom row -> Total number of unique sales */}
              <div
                className="flex"
                style={{
                  border: "1px solid rgba(0,0,0,0.1)",
                  fontSize: "12px",
                }}
              >
                <div
                  className="mt-2.5 mb-2.5 fw-bold pl-2 text-nowrap"
                  style={{
                    width: `${isMobile ? "32%" : titleFlag ? "30%" : "29%"}`,
                    maxWidth: `${layoutWidthFlag ? "22vw" : "24.5vw"}`,
                  }}
                >
                  Total Number of Unique Sales
                </div>
                {/* Div for spacing */}
                <div
                  style={{
                    width: `${isMobile ? "34%" : titleFlag ? "32%" : "31%"}`,
                  }}
                />
                {/* Sum of all unique sales numbers */}
                <div className="flex mt-2.5 text-nowrap fw-bold">
                  {currentSources?.length >= currentDate - 1 &&
                    currentSources[currentDate]
                      ?.map((val) => val["no_of_sales"])
                      .reduce((sum, value) => sum + value, 0)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function ModalDisplay({
  modalData,
  modalBoxFlag,
  currentDate,
  dates,
  openModal,
  handleClose,
  dateType,
}) {
  const [currData, setCurrData] = React.useState(modalData);

  // Rotate curerent subdata displayed by clicking next button
  function rotateData(dir) {
    // Currently on last subdata, switch to first
    if (dir === "forward") {
      if (currData.data?.length - 1 === currData.idx) {
        setCurrData({
          data: currData.data,
          idx: 0,
        });
      } else {
        setCurrData({
          data: currData.data,
          idx: currData.idx + 1,
        });
      }
    } else {
      if (0 === currData.idx) {
        setCurrData({
          data: currData.data,
          idx: currData.data?.length - 1,
        });
      } else {
        setCurrData({
          data: currData.data,
          idx: 0,
        });
      }
    }
  }

  useEffect(() => {
    setCurrData(modalData);
  }, [modalData]);

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{ "& .MuiBackdrop-root": { backgroundColor: "rgba(0,0,0,0.7)" } }}
    >
      <div
        className="absolute flex flex-col align-items-center justify-content-center bg-[rgba(225,205,205)] rounded-3"
        style={{ width: "100%", top: "15%", height: "70%", zIndex: "100" }}
      >
        <div className="mb-4 absolute" style={{ fontSize: "17px", top: "5vh" }}>
          Individual User Traffic Conversion Insight
        </div>

        <div
          className="modal__top__labels mb-1.5"
          style={{
            marginTop: "-26px",
            fontSize: `${modalBoxFlag ? "13.3px" : "14.5px"}`,
          }}
        >
          <div
            className={`${modalBoxFlag ? "gap-2.5" : "gap-5"} flex`}
            style={{ width: "70%", maxWidth: "60vw" }}
          >
            <div
              style={{
                width: `${modalBoxFlag ? "50%" : ""}`,
                wordWrap: "break-word",
              }}
            >
              <b>First Source: </b>
              {currData["data"][currData.idx].first_source}
            </div>
            <div
              style={{
                width: `${modalBoxFlag ? "50%" : ""}`,
                wordWrap: "break-word",
              }}
            >
              <b>Last Source: </b>
              {currData["data"][currData.idx].last_source}
            </div>
          </div>
          <div>
            <b>{DATEOPTIONS[dateType]?.slice(0, -2)}: </b>
            {dates[currentDate]}
          </div>
        </div>

        {/* Data Grid */}
        <div
          className="modal__touch flex flex-col bg-[white] rounded-2 "
          style={{ maxHeight: "38vh", overflowY: "scroll" }}
        >
          {/* Labels row */}
          <div className="modal__labels flex bg-[rgb(0,0,0,0.1)]">
            <div className="modal__box">
              {modalBoxFlag ? "sales" : "sales_done"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "referrers" : "referrer_sources"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "campaignid" : "utm_campaignid"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "campaign" : "utm_campaign"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "content" : "utm_content"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "medium" : "utm_medium"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "network" : "utm_network"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "source" : "utm_source"}
            </div>
            <div className="modal__box">
              {modalBoxFlag ? "term" : "utm_term"}
            </div>
            <div className="modal__box modal__box__right">gclid</div>
          </div>

          {/* Current subdata */}
          {currData.data[currData.idx].subData?.length > 0 ? (
            <div>
              {currData.data[currData.idx].subData?.map((value, index) => (
                <div key={index}>
                  {value.user_source === undefined ? (
                    // for organic organic (no value.user_source)
                    <div
                      className="flex"
                      style={{ borderTop: "1px solid rgba(0,0,0,0.3)" }}
                    >
                      <div className="modal__box">{value.no_of_sales}</div>
                      <div className="modal__box">{value.referrers[0]}</div>
                      <div className="modal__box"></div>
                      <div className="modal__box"></div>
                      <div className="modal__box"></div>
                      <div className="modal__box"></div>
                      <div className="modal__box"></div>
                      <div className="modal__box"></div>
                      <div className="modal__box"></div>
                      <div className="modal__box modal__box__right"></div>
                    </div>
                  ) : (
                    <div
                      className="flex"
                      style={{ borderTop: "1px solid rgba(0,0,0,0.3)" }}
                    >
                      <div className="modal__box">{value.no_of_sales}</div>
                      <div className="modal__box">{value.referrers[0]}</div>
                      <div className="modal__box">
                        {value.user_source.utm_campaignid &&
                          value.user_source.utm_campaignid}
                      </div>
                      <div className="modal__box">
                        {value.user_source.utm_campaign &&
                          value.user_source.utm_campaign}
                      </div>
                      <div className="modal__box">
                        {value.user_source.utm_content &&
                          value.user_source.utm_content}
                      </div>
                      <div className="modal__box">
                        {value.user_source.utm_medium &&
                          value.user_source.utm_medium}
                      </div>
                      <div className="modal__box">
                        {value.user_source.utm_network &&
                          value.user_source.utm_network}
                      </div>
                      <div className="modal__box">
                        {value.user_source.utm_source &&
                          value.user_source.utm_source}
                      </div>
                      <div className="modal__box">
                        {value.user_source.utm_term &&
                          value.user_source.utm_term}
                      </div>
                      <div
                        className={`modal__box modal__box__right ${
                          value.user_source.gclid === undefined
                            ? ""
                            : value.user_source.gclid.toString()?.length > 30
                            ? "large__gclid"
                            : ""
                        }`}
                      >
                        {value.user_source.gclid && value.user_source.gclid}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div
              className="flex justify-content-center py-3"
              style={{ borderTop: "1px solid rgba(0,0,0,0.3)" }}
            >
              <div>No Data Found</div>
            </div>
          )}
        </div>

        {/* Next, close buttons */}
        <div
          className="absolute flex mt-3 gap-4 justify-content-center"
          style={{ top: "57vh" }}
        >
          <button
            className="modal__button__right bg-[rgba(100,0,20)] px-3.5 py-1 text-white rounded-2"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="modal__button__middle bg-[rgba(100,90,20)] px-3.5 py-1 text-white rounded-2"
            onClick={() => rotateData("back")}
          >
            Back
          </button>
          <button
            className="modal__button__left bg-[rgba(0,90,100)] px-3.5 py-1 text-white rounded-2"
            onClick={() => rotateData("forward")}
          >
            Next
          </button>
        </div>
      </div>
    </Modal>
  );
}
